import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Modal, toast } from '../../../ui';
import { useBankAccounts } from '../../../hooks/useFinancialOps';
import { useUploadBankImport } from '../hooks/useBankImports';

interface Props {
  open: boolean;
  onClose: () => void;
  companyId: string;
}

export function ImportarExtratoDialog({ open, onClose, companyId }: Props) {
  const navigate = useNavigate();
  const { data: accountsData } = useBankAccounts(companyId, { active: true });
  const accounts = accountsData?.data ?? [];
  const [bankAccountId, setBankAccountId] = useState('');
  const [file, setFile] = useState<File | null>(null);
  const upload = useUploadBankImport();

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!bankAccountId || !file) {
      toast.error('Selecione a conta bancária e o arquivo .ofx.');
      return;
    }
    try {
      const result = await upload.mutateAsync({ bankAccountId, file });
      const sessionId = result?.data?.session?.id;
      onClose();
      if (sessionId) {
        navigate(`/financeiro/importacoes/${sessionId}`);
      }
    } catch (err: any) {
      const status = err?.response?.status;
      const data = err?.response?.data;
      if (status === 409 && data?.existingSessionId) {
        toast.error('Este arquivo já foi importado nesta conta.');
        navigate(`/financeiro/importacoes/${data.existingSessionId}`);
        onClose();
        return;
      }
      toast.error(data?.message || err?.message || 'Falha ao importar.');
    }
  }

  return (
    <Modal open={open} onClose={onClose} title="Importar extrato bancário">
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="text-sm text-ink-secondary">Conta bancária</label>
          <select
            className="w-full border rounded px-2 py-1"
            value={bankAccountId}
            onChange={(e) => setBankAccountId(e.target.value)}
          >
            <option value="">Selecione…</option>
            {accounts.map((a: any) => (
              <option key={a.id} value={a.id}>
                {a.bankName} — {a.name}
              </option>
            ))}
          </select>
        </div>
        <div>
          <label className="text-sm text-ink-secondary">Arquivo .ofx ou .qfx (≤10MB)</label>
          <input
            type="file"
            accept=".ofx,.qfx"
            onChange={(e) => setFile(e.target.files?.[0] ?? null)}
            className="block w-full"
          />
        </div>
        <div className="flex gap-2 justify-end">
          <Button type="button" variant="ghost" onClick={onClose}>
            Cancelar
          </Button>
          <Button type="submit" disabled={upload.isPending}>
            {upload.isPending ? 'Enviando…' : 'Importar'}
          </Button>
        </div>
      </form>
    </Modal>
  );
}
